var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { bindable, computedFrom } from "aurelia-framework";
import { PurchasedItemModel } from "../../../../models/modules/lotteryplatform-client.models";
import * as Enumerable from "linq";
import moment from "moment";
import { LotteryKeyHelper } from "../../../../services/modules/brand-client.service";
var BaseTicket = /** @class */ (function () {
    function BaseTicket(tokenClient) {
        this.tokenClient = tokenClient;
        this.defaultUserCurrencySymbol = tokenClient.getUserCurrency().symbol;
    }
    Object.defineProperty(BaseTicket.prototype, "tickets", {
        get: function () {
            return this.item ? Enumerable.from(this.item.tickets).groupBy(function (x) { return x.lotteryJackpotDrawId; }).toArray() : [];
        },
        enumerable: false,
        configurable: true
    });
    BaseTicket.prototype.getDrawDate = function (item) {
        var dates = Enumerable.from(item.tickets).select(function (x) { return new Date(x.drawDate); });
        var from = dates.orderBy(function (x) { return x; }).firstOrDefault();
        var to = dates.orderByDescending(function (x) { return x; }).firstOrDefault();
        var fromStr = moment(from).format("MMM Do YYYY HH:mm:ss");
        var toStr = moment(to).format("MMM Do YYYY HH:mm:ss");
        if (fromStr == toStr)
            return fromStr;
        return "".concat(fromStr, " - ").concat(toStr);
    };
    BaseTicket.prototype.getLotteryKey = function (lotteryName) {
        return LotteryKeyHelper.getKey(lotteryName);
    };
    __decorate([
        bindable,
        __metadata("design:type", PurchasedItemModel)
    ], BaseTicket.prototype, "item", void 0);
    __decorate([
        computedFrom("item"),
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], BaseTicket.prototype, "tickets", null);
    return BaseTicket;
}());
export { BaseTicket };
